module.exports = __webpack_public_path__ + "ae709d4fc3196d119faff40e4b791f93.svg";